exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#moneyChart[data-v-365fa7ac]{height:6.66667rem}.num-content div[data-v-365fa7ac]{cursor:pointer}.num-content div[data-v-365fa7ac]:hover{color:#409eff}", ""]);

// exports
